import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { clearAuth, isStoredAuthExpired, isAuthenticated } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    const expired = isStoredAuthExpired();

    if (expired) {
      clearAuth();
    }

    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
          },
          message: expired
            ? "Sesi Anda sudah habis. Silakan login kembali."
            : "Silakan login terlebih dahulu untuk melanjutkan.",
        }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;